import { resetAuthGuardCache } from '@/lib/auth-guard';
import { logout } from '@/lib/auth-service';
import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

/**
 * Shared logout behaviour: ends the Tahiti session, clears the cached guard
 * status, then redirects to `/login`. Used by the rail (desktop) and the
 * settings page (mobile) so there is a single logout implementation.
 */
export function useLogout(): { handleLogout: () => void; pending: boolean } {
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);

  async function run(): Promise<void> {
    setPending(true);
    // Log out locally regardless of the network result — a failed call must not
    // leave the user stuck or surface an unhandled rejection.
    try {
      await logout();
    } catch {
      // ignore: clear local state + redirect below
    }
    resetAuthGuardCache();
    void navigate({ to: '/login' });
  }

  return { handleLogout: () => void run(), pending };
}
